/**
 * The entity's tenant-facing name (DP-7728).
 *
 * The configured display name wins, else the schema title. A blank name counts
 * as absent rather than as an override to nothing: the BE forbids one, but a
 * document written before that constraint would otherwise render an empty
 * title instead of falling back.
 *
 * Shared because the details page and the peeked custom section mount the same
 * record from two surfaces — resolving it twice is how they drifted apart.
 */
export function resolveEntityTitle(
  displayName: string | undefined,
  schemaTitle: string | undefined
): string {
  const configured = displayName?.trim() ?? '';
  return configured !== '' ? configured : (schemaTitle ?? '');
}
